import { IRootState } from "./types/rootReducers.t";
import { createSelector } from "reselect";
import { getAppUser } from "./appSelectors";

const userSelector = (state: IRootState) => state.user;

export const getUsesStatusesSelector = createSelector(userSelector, state => state.userStatuses);
export const getUsesStatusesErrorSelector = createSelector(userSelector, state => state.userStatusesError);
export const getUsesStatusesLoadingSelector = createSelector(userSelector, state => state.userStatusesLoading);

export const getRespawnMotivationSelector = createSelector(userSelector, state => state.respawnMotivation);

export const getUserStatusParamsSelector = createSelector([getAppUser, getUsesStatusesSelector], (user, userStatuses) =>
    userStatuses.find(item => item.status_name === user.user_status)
);
